
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("iTLsD"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("iTLsD", function(module, exports) {

let $dc222dcf03fc1a3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dc222dcf03fc1a3b$var$load("fSobj"),
    $dc222dcf03fc1a3b$var$load("74u2y"),
    $dc222dcf03fc1a3b$var$load("2YffH"),
    $dc222dcf03fc1a3b$var$load("iDB1L"),
    $dc222dcf03fc1a3b$var$load("eEyVs"),
    $dc222dcf03fc1a3b$var$load("6mHrv"),
    $dc222dcf03fc1a3b$var$load("awWN9"),
    $dc222dcf03fc1a3b$var$load("agAjs"),
    $dc222dcf03fc1a3b$var$load("9CYct"),
    $dc222dcf03fc1a3b$var$load("iIoyG"),
    $dc222dcf03fc1a3b$var$load("2xn4F"),
    $dc222dcf03fc1a3b$var$load("hZtKG"),
    $dc222dcf03fc1a3b$var$load("iNmaF"),
    $dc222dcf03fc1a3b$var$load("lVO3w"),
    $dc222dcf03fc1a3b$var$load("hyzoX"),
    $dc222dcf03fc1a3b$var$load("h9Ed7"),
    $dc222dcf03fc1a3b$var$load("eBRUf"),
    $dc222dcf03fc1a3b$var$load("j8gSv"),
    $dc222dcf03fc1a3b$var$load("8hnOL"),
    $dc222dcf03fc1a3b$var$load("gVbhn"),
    $dc222dcf03fc1a3b$var$load("8A3nE"),
    $dc222dcf03fc1a3b$var$load("8YSo7"),
    $dc222dcf03fc1a3b$var$load("g7ggm"),
    $dc222dcf03fc1a3b$var$load("9S9Mz"),
    $dc222dcf03fc1a3b$var$load("kiGNy"),
    $dc222dcf03fc1a3b$var$load("fuKGN"),
    $dc222dcf03fc1a3b$var$load("4IYLb"),
    $dc222dcf03fc1a3b$var$load("7Ftdh"),
    $dc222dcf03fc1a3b$var$load("g9CVe"),
    $dc222dcf03fc1a3b$var$load("7oiUM"),
    $dc222dcf03fc1a3b$var$load("8t3po"),
    $dc222dcf03fc1a3b$var$load("855o0"),
    $dc222dcf03fc1a3b$var$load("8MfZE"),
    $dc222dcf03fc1a3b$var$load("hv4mn"),
    $dc222dcf03fc1a3b$var$load("dek7I"),
    $dc222dcf03fc1a3b$var$load("3SmkN"),
    $dc222dcf03fc1a3b$var$load("dYtBN"),
    $dc222dcf03fc1a3b$var$load("kNV5Y"),
    $dc222dcf03fc1a3b$var$load("6wr18"),
    $dc222dcf03fc1a3b$var$load("kjZZD"),
    $dc222dcf03fc1a3b$var$load("7nW1A"),
    $dc222dcf03fc1a3b$var$load("cM9rX"),
    $dc222dcf03fc1a3b$var$load("9u7sS"),
    $dc222dcf03fc1a3b$var$load("1fem1"),
    $dc222dcf03fc1a3b$var$load("Wowvf"),
    $dc222dcf03fc1a3b$var$load("ffEVr"),
    $dc222dcf03fc1a3b$var$load("hhss7"),
    $dc222dcf03fc1a3b$var$load("dTsOE"),
    $dc222dcf03fc1a3b$var$load("8hq1F"),
    $dc222dcf03fc1a3b$var$load("7FF6A"),
    $dc222dcf03fc1a3b$var$load("henq4"),
    $dc222dcf03fc1a3b$var$load("k5Ch2"),
    $dc222dcf03fc1a3b$var$load("djob1"),
    $dc222dcf03fc1a3b$var$load("8fMw3"),
    $dc222dcf03fc1a3b$var$load("hogcU"),
    $dc222dcf03fc1a3b$var$load("fjYIR"),
    $dc222dcf03fc1a3b$var$load("h3ABO"),
    $dc222dcf03fc1a3b$var$load("kC80R"),
    $dc222dcf03fc1a3b$var$load("7EorR"),
    $dc222dcf03fc1a3b$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.a8644fd7.js.map
